import type { GameHudView } from '@/gameplay/types'
import { formatTime } from '@/persistence/records'
import { useAppStore } from '@/hud-bridge/store'

interface Props {
  hud: GameHudView
  isTouch: boolean
}

export function GameHud({ hud, isTouch }: Props) {
  const setScreen = useAppStore((s) => s.setScreen)

  return (
    <div className="hud-layer" aria-hidden={false}>
      <div className="hud-top">
        <div className="hud-top-left">
          <div className="hud-chip" style={{ color: hud.mode === 'exit' ? 'var(--info)' : 'var(--safe)' }}>
            {hud.mode === 'exit' ? 'EXIT' : 'CLEAR'}
            <span style={{ color: 'var(--text-secondary)', fontSize: 12 }}>
              {hud.mode === 'exit' ? 'Выход' : 'Очистка'}
            </span>
          </div>
          {/* Clear: ACT+DEF крупно всегда; Exit B1: только DEF при >0 */}
          {hud.mode === 'clear' ? (
            <div className="hud-mine-row">
              <div className="hud-stat" style={{ color: 'var(--warn)' }}>
                <span className="hud-stat-label">ACT</span>
                <span className="hud-stat-value">{hud.activeMines}</span>
              </div>
              <div className="hud-stat" style={{ color: 'var(--safe)' }}>
                <span className="hud-stat-label">DEF</span>
                <span className="hud-stat-value">{hud.defusedCount}</span>
              </div>
            </div>
          ) : hud.defusedCount > 0 ? (
            <div className="hud-stat" style={{ color: 'var(--safe)' }}>
              <span className="hud-stat-label">DEF</span>
              <span className="hud-stat-value">{hud.defusedCount}</span>
            </div>
          ) : null}
        </div>
      </div>

      <div className="hud-top-center">
        <div className="hud-chip">{formatTime(hud.timerMs)}</div>
        <div className="hud-chip" style={{ fontSize: 12, color: 'var(--text-secondary)' }}>
          {hud.cameraMode.toUpperCase()}
        </div>
      </div>

      {/* Adjacent текущей / виртуальной входной клетки */}
      <div className="hud-scan">
        <div className="hud-chip scan-chip">
          <span className="scan-label">ADJ</span>
          <span className="scan-value">
            {hud.adjacentCount === null ? '—' : hud.adjacentCount}
          </span>
        </div>
      </div>

      <div className="crosshair" />

      {hud.defuse.active ? (
        <div className="defuse-badge">
          <div className="defuse-label">DEFUSE</div>
          <div className="defuse-bar">
            <div className="defuse-fill" style={{ width: `${Math.round(hud.defuse.t * 100)}%` }} />
          </div>
        </div>
      ) : (
        <div className="defuse-badge idle" style={{ color: 'var(--text-secondary)' }}>
          Hold
        </div>
      )}

      {hud.hint && !isTouch && <div className="hint">{hud.hint}</div>}

      {!isTouch && (
        <button
          className="btn btn-ghost"
          style={{ position: 'absolute', top: 12, right: 12, minHeight: 36, pointerEvents: 'auto' }}
          onClick={() => setScreen('paused')}
          type="button"
        >
          Pause
        </button>
      )}
    </div>
  )
}
